import React from "react";
import Inbox from "@/components/messages/Inbox";
export default function PatientMessages() { return <Inbox role="patient"/>; }
